import LeaveTeamEditor from 'actions/teams/leave_team_editor';
import OpenTeam from 'actions/teams/open_team';
import { registerUrlConverter } from './location_url';
import UnloadUsersAdmin from 'actions/users/unload_users_admin';
import TeamEditor from 'models/location/team_editor';

registerUrlConverter(TeamEditor, { getPath: te => `/teams/${te.teamId || 'new'}` });

export default function(router, { runnerContext }) {
  return {
    '/new': {
      on: () => {
        runnerContext.executeAction(OpenTeam);
      },
      after: () => {
        runnerContext.executeAction(LeaveTeamEditor);
      },
    },
    '/:teamId': {
      on: teamId => {
        runnerContext.executeAction(OpenTeam, teamId);
      },
      after: () => {
        let teamsRouteRegExp = /\/teams\/([^/]+)/;
        let currentTeamRoute = teamsRouteRegExp.exec(router.beforeUnloadUrl);
        if (!currentTeamRoute) {
          return;
        }
        runnerContext.executeAction(LeaveTeamEditor, currentTeamRoute[1]);
      },
    },
    after() {
      if (!router.getPath().startsWith('/users') && !router.getPath().startsWith('/teams')) {
        runnerContext.executeAction(UnloadUsersAdmin);
      }
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/teams_routes.js